module.exports = "<pre>\n{{breadcrumbs | json}}\n</pre>\n"